import styled from "@emotion/styled";
import {
  COLOR_PRIMARY,
  LINE_HEIGHT_DEFAULT,
  FONT_SIZE_SMALL,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_MEDIUM_MOBILE,
  FONT_SIZE_LARGE,
  FONT_SIZE_XLARGE,
  LINE_HEIGHT_XLARGE,
  MOBILE_SCREEN,
  FONT_SIZE_SMALL_MOBILE,
  TEXT_FONT_FAMILY,
  HEADER_FONT_FAMILY,
  FONT_SIZE_XSMALL,
  COLOR_APP_TEXT,
} from "../theme";

interface TextProps {
  marginTop?: string;
  marginBottom?: string;
  textAlign?: React.CSSProperties["textAlign"];
  marginLeft?: string;
  marginRight?: string;
  color?: string;
  fontWeight?: number;
}

export const Paragraph = styled.p<TextProps>`
  font-family: ${TEXT_FONT_FAMILY};
  font-size: ${FONT_SIZE_MEDIUM};
  line-height: ${LINE_HEIGHT_DEFAULT};
  font-weight: ${({ fontWeight }) => fontWeight ?? 300};
  color: ${({ color }) => color ?? COLOR_APP_TEXT};
  text-align: ${({ textAlign }) => textAlign ?? "inherit"};
  margin-top: ${({ marginTop }) => marginTop ?? "0"};
  margin-right: ${({ marginRight }) => marginRight ?? "0"};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? "0"};
  margin-left: ${({ marginLeft }) => marginLeft ?? "0"};
`;

export const ParagraphHeader = styled.p<TextProps>`
  font-family: ${HEADER_FONT_FAMILY};
  font-size: ${FONT_SIZE_MEDIUM};
  line-height: ${LINE_HEIGHT_DEFAULT};
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  color: ${({ color }) => color ?? COLOR_APP_TEXT};
  text-align: ${({ textAlign }) => textAlign ?? "inherit"};
  margin-top: ${({ marginTop }) => marginTop ?? "0"};
  margin-right: ${({ marginRight }) => marginRight ?? "0"};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? "0"};
  margin-left: ${({ marginLeft }) => marginLeft ?? "0"};
`;

export const ParagraphXSmall = styled(Paragraph)`
  font-size: ${FONT_SIZE_XSMALL};
  font-weight: 300;
  line-height: 16px;
`;

export const ParagraphSmall = styled(Paragraph)`
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${({ fontWeight }) => fontWeight ?? 300};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_SMALL_MOBILE};
  }
`;
export const ParagraphMedium = styled(Paragraph)`
  font-size: ${FONT_SIZE_MEDIUM};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_MEDIUM_MOBILE};
  }
`;

export const ParagraphHeaderSmall = styled(ParagraphHeader)`
  font-size: ${FONT_SIZE_SMALL};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_SMALL_MOBILE};
  }
`;

export const ParagraphHeaderXSmall = styled(ParagraphHeader)`
  font-size: ${FONT_SIZE_SMALL_MOBILE};
`;

export const ParagraphHeaderXLarge = styled(ParagraphHeader)`
  font-size: ${FONT_SIZE_XLARGE};
  color: ${COLOR_APP_TEXT};
  line-height: ${LINE_HEIGHT_XLARGE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_MEDIUM};
  }
`;

export const ParagraphHeaderLarge = styled(ParagraphHeader)`
  font-size: ${FONT_SIZE_LARGE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_MEDIUM};
  }
`;

export const ParagraphLarge = styled(Paragraph)`
  font-size: ${FONT_SIZE_LARGE};
`;

export const ParagraphXLarge = styled(Paragraph)`
  font-size: ${FONT_SIZE_XLARGE};
  line-height: ${LINE_HEIGHT_XLARGE};
`;

export const Bold = styled.strong<TextProps>`
  font-family: ${HEADER_FONT_FAMILY};
  font-size: ${FONT_SIZE_MEDIUM};
  font-weight: 600;
  line-height: ${LINE_HEIGHT_DEFAULT};
  color: ${(props) => props.color ?? { COLOR_PRIMARY }};
  text-align: ${(props) => props.textAlign ?? "center"};
  margin-top: ${(props) => props.marginTop ?? "0"};
  margin-bottom: ${(props) => props.marginBottom ?? "0"};
  margin-left: ${(props) => props.marginLeft ?? "0"};
  margin-right: ${(props) => props.marginRight ?? "0"};
`;

export const Semibold = styled.strong<TextProps>`
  font-family: ${TEXT_FONT_FAMILY};
  font-size: ${FONT_SIZE_MEDIUM};
  line-height: ${LINE_HEIGHT_DEFAULT};
  font-weight: 500;
  color: ${({ color }) => color ?? COLOR_PRIMARY};
  text-align: ${({ textAlign }) => textAlign ?? "inherit"};
  margin-top: ${({ marginTop }) => marginTop ?? "0"};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? "0"};
  margin-left: ${({ marginLeft }) => marginLeft ?? "0"};
  margin-right: ${({ marginRight }) => marginRight ?? "0"};
`;

export const SemiboldSmall = styled(Semibold)`
  font-size: ${FONT_SIZE_SMALL};
`;
